import { Link } from 'react-router-dom';
import { DISCLAIMER } from '@/constants/testIds/healthspan';

export default function FooterDisclaimer() {
  return (
    <footer data-testid={DISCLAIMER.footer} className="mt-16 border-t border-[color:var(--border-color)] bg-[color:var(--surface)]">
      <div className="mx-auto max-w-[var(--container)] px-4 sm:px-6 lg:px-8 py-8 grid gap-6 md:grid-cols-3">
        <div>
          <div className="text-sm font-semibold tracking-tight">Telogenis — Healthspan Optimization Engine</div>
          <p className="mt-2 text-xs leading-5 text-[color:var(--muted-fg)]">
            Translating longevity research into transparent, citation-first protocols. Built for researchers, clinicians, and informed laypeople.
          </p>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-[color:var(--muted-fg)]">Navigate</div>
          <ul className="mt-2 space-y-1 text-sm">
            <li><Link to="/match" className="hover:underline">Biomarker match</Link></li>
            <li><Link to="/protocols" className="hover:underline">Protocol catalogue</Link></li>
            <li><Link to="/trials" className="hover:underline">Clinical trials</Link></li>
            <li><Link to="/legal/disclaimer" className="hover:underline">Full medical disclaimer</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-[color:var(--muted-fg)]">Medical disclaimer</div>
          <p data-testid={DISCLAIMER.footerText} className="mt-2 text-xs leading-5 text-[color:var(--muted-fg)]">
            This application is for educational and research purposes only and does not provide medical advice. Do not use this information to diagnose or treat any health condition. Consult a qualified healthcare professional before making any health decisions.
          </p>
        </div>
      </div>
      <div className="border-t border-[color:var(--border-color)]">
        <div className="mx-auto max-w-[var(--container)] px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
          <p className="text-[11px] text-[color:var(--muted-fg)]">© {new Date().getFullYear()} Telogenis. Citation-first research tooling.</p>
          <p className="text-[11px] text-[color:var(--muted-fg)]">Stripe checkout runs in TEST mode in this environment.</p>
        </div>
      </div>
    </footer>
  );
}
